import React from 'react';

import CreateEditHazardFormUi from '../CreateEditHazardFormUi';
import { domainType } from '../../constants';

const EditHazardDialog = (props) => {
  const {
    hazard,
    openDialog,
    isSaving,
    onHandleInputChange,
    openCreateHazardDialog,
    submitHazard,
    branchId,
    allAttachments,
    onRemoveAttachment,
    fetchExistingAttachmentsForTheHazard,
    loggedInUser,
    openDocumentListDialog,
    documents
  } = props;

  const handleSubmit = (e) => {
    e.preventDefault();
    hazard.branchId = branchId;
    submitHazard(hazard);
  };
  const handleRemoveAttachment = (attachment) => {
    onRemoveAttachment(attachment);
  };

  const handleAttahmentChange = (value, inputFieldName) => {
    const { onUpdateAttachment } = props;
    onUpdateAttachment(value, inputFieldName);
  };

  return (
    <React.Fragment>
      <CreateEditHazardFormUi
        openDialog={openDialog}
        isSaving={isSaving}
        onHandleInputChange={onHandleInputChange}
        openCreateHazardDialog={openCreateHazardDialog}
        handleSubmit={handleSubmit}
        title="Hazard Detail"
        hazard={hazard}
        documents={documents}
        actionButtonText="Update"
        allAttachments={allAttachments}
        handleRemoveAttachment={handleRemoveAttachment}
        handleAttahmentChange={handleAttahmentChange}
        documents={documents}
        canEditDocuments={true}
        openDocumentListDialog={openDocumentListDialog}
      />
    </React.Fragment>
  );
};

export default EditHazardDialog;
